import { map } from 'rxjs/operators';
import { ConfigurationData } from '../models/configuration-data.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { UrlConfigService } from '@hrra/core';

@Injectable()
export class ConfigurationService {
  private config: ConfigurationData;

  public loadAllConfigs(): Observable<boolean> {
    return this.ajax
      .getData(
        this.urlService.urlConfig.api.data.configuration.multi.get,
        {},
        ConfigurationData
      )
      .pipe(
        map((d) => {
          this.config = d;
          return true;
        })
      );
  }

  public getCachedConfig(): ConfigurationData {
    return this.config;
  }

  //TODO get with cache check

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
